import Button from '@material-ui/core/Button';
import DialogProvider from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconCancel from '@material-ui/icons/Cancel';
import IconCheck from '@material-ui/icons/Check';
import React from "react";
import ButtonWithStore from "./ButtonWithStore";




export default class Dialog extends React.Component {
  static defaultProps = {
    show: false,
    title: '',
    content: '',
    id: '',
    onClick: (data) => { console.log(data); },
    triggerHide: () => { this.setState({ show: false }); },
    contentPadding:false,
    loading:false,
    maxWidth:'sm',
  };

  state = this.initialState();

  initialState() {
    return {
      show: false,
    };
  }
  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */
  show = () => {
    this.setState({ ...this.initialState(), show: true });
  }
  onPreparOnClick = (store) => {
    this.props.onClick(store, this.state.id);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      show: nextProps.show,
      id: nextProps.id,
    });
  }


  render() {
    const { show } = this.state;
    return (
      <DialogProvider
        fullWidth
        open={show}
        onClose={this.handleCloseClick}
        aria-label={this.props.title}
        maxWidth={this.props.maxWidth}
      >
        <DialogTitle>{this.props.title}</DialogTitle>
        <DialogContent className={this.props.contentPadding?'':'nopadding'}>{this.props.content?this.props.content:this.props.children}</DialogContent>
        <DialogActions>
          {this.props.onClick &&
            <ButtonWithStore
              action={this.onPreparOnClick}
              variant="outlined"
              disabled={this.props.loading}
              title={<IconCheck />}
            >
            </ButtonWithStore>
          }
          <Button variant="outlined" label="ra.action.cancel" onClick={this.props.triggerHide}>
            <IconCancel />
          </Button>
        </DialogActions>
      </DialogProvider>
    )
  }

}